export default __webpack_public_path__ + "static/bw-academy-c2e152bc8e5fb615a2e79eb937a97f89.jpg";